
import {initWebComponent} from "@/helpers/web-component-helper";
import {bytesToSize} from "@/helpers/file-helper";
import {getAttributeItemByFeatureInfo, getFeatureInfoByFeatureInfoKey} from "@/helpers/plugin-helper";
import {generateMetaDataHtml} from "@/helpers/meta-data-helper";
import {getKVLayerByBookmarkPresentationID} from "@/helpers/kv/kv-layer-helper";

export class LayerInfoInfoPluginComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        const index = this.getAttribute('data-main-tab-index')
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')
        const mainTab = window.mainTabs[index]

        const featureInfo = getFeatureInfoByFeatureInfoKey(featureKey, featureInfoKey)

        let innerHTML = ``
        switch (featureInfo.FormType) {
            // Bestanden die beginnen met gekozen attribuut
            case 12:
            // Bestanden uit gekozen directory
            case 16:
                const attributeItem = getAttributeItemByFeatureInfo(featureInfo)
                attributeItem.DomainList.DomainListItems.map( (domainListItem, key) => {
                    innerHTML += `<layer-info-info-plugin-file-item data-domain-list-key="${key}" data-feature-key="${featureKey}" data-main-tab-index="` + index + `" data-feature-info-key="` + featureInfoKey + `"></layer-info-info-plugin-file-item>`;
                })
                break;
            // Cyclorama
            case 13:
                innerHTML += `<layer-info-info-plugin-cyclorama data-feature-key="${featureKey}" data-main-tab-index="` + index + `" data-feature-info-key="` + featureInfoKey + `"></layer-info-info-plugin-cyclorama>`;
                break;
            // Word rapportage
            case 15:
                innerHTML += `<layer-info-info-plugin-word data-feature-key="${featureKey}" data-main-tab-index="` + index + `" data-feature-info-key="` + featureInfoKey + `"></layer-info-info-plugin-word>`;
                break;
            // Orbit
            case 21:
                innerHTML += `<layer-info-info-plugin-orbit data-feature-key="${featureKey}" data-main-tab-index="` + index + `" data-feature-info-key="` + featureInfoKey + `"></layer-info-info-plugin-orbit>`;
                break;
            // Kavel10
            case 22:
                innerHTML += `<layer-info-info-plugin-kavel10 data-feature-key="${featureKey}" data-main-tab-index="` + index + `" data-feature-info-key="` + featureInfoKey + `"></layer-info-info-plugin-kavel10>`;
                break;
            // Metadata
            case 23:
                const kvLayer = getKVLayerByBookmarkPresentationID(mainTab.BookmarkPresentationID)
                if(kvLayer) {
                    innerHTML += '<div class="ml-2 mr-2">' + generateMetaDataHtml(kvLayer.MetaData) + '</div>'
                }
                break;
            case 24:
                innerHTML += '<div class="ml-2 mr-2">' + generateMetaDataHtml(getKVLayerByBookmarkPresentationID(mainTab.BookmarkPresentationID).MetaData, true) + '</div>'
                break;
        }

        template.innerHTML = innerHTML
        initWebComponent(this, template)
    }
}

